import { PAGE_VIEW } from 'Store/constants';

export const pageView = (title, url) => dispatch => {
  dispatch({
    type: PAGE_VIEW, payload: {
      title,
      url
    }
  });
};